import axios from 'shared/api/axios';

import type { InboundConfig } from '../types';

export const updateSettings = async (data: InboundConfig) => {
  const res = await axios.post('/api/v1/ai-chatbots/inbound-ai-rep/settings', data);
  return res.data;
};
